import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';
import { useLang } from '../../contexts/LangContext';
import AlunaTabBar from '../../components/AlunaTabBar';
import { QUESTIONARIOS, TIPOS } from '../../lib/questionarios';

function IconClipboard() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4h6v3H9z" />
      <path d="M15 4h3a1 1 0 0 1 1 1v16H5V5a1 1 0 0 1 1-1h3" />
      <path d="M8 13h8" />
      <path d="M8 17h5" />
    </svg>
  );
}

export default function AlunaQuestionarios() {
  const { user } = useAuth();
  const { lang } = useLang();
  const navigate = useNavigate();
  const [respondidos, setRespondidos] = useState({}); // tipo -> data da última resposta
  const [loading, setLoading] = useState(true);
  const isPt = lang === 'pt';

  useEffect(() => {
    if (!user?.id) return;
    supabase.from('questionario_respostas').select('tipo, created_at').eq('aluna_id', user.id).order('created_at', { ascending: false })
      .then(({ data }) => {
        const map = {};
        (data || []).forEach(r => { if (!map[r.tipo]) map[r.tipo] = r.created_at; });
        setRespondidos(map);
        setLoading(false);
      });
  }, [user]);

  const fmtDate = iso => new Date(iso).toLocaleDateString(isPt ? 'pt-BR' : 'en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const totalRespondidos = Object.keys(respondidos).length;
  const progresso = Math.round((totalRespondidos / TIPOS.length) * 100);

  return (
    <div style={{ minHeight: '100vh', background: '#f3eee7', padding: '26px 14px 40px', fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Inter', sans-serif", color: '#1d1d1f' }}>
      <style>{`
        @media(max-width:560px){
          body, #root { background:#fffaf4 !important; }
          .aluna-questionarios-shell { width:100% !important; min-height:100dvh !important; border-radius:0 !important; box-shadow:none !important; padding:calc(env(safe-area-inset-top, 0px) + 20px) 16px calc(132px + env(safe-area-inset-bottom, 0px)) !important; }
        }
      `}</style>
      <div className="aluna-questionarios-shell" style={{ width: 'min(100%, 430px)', minHeight: 'calc(100vh - 56px)', margin: '0 auto', borderRadius: '44px', padding: '28px 22px 118px', background: '#fffaf4', boxShadow: '0 28px 80px rgba(66,44,38,.10), inset 0 1px 0 rgba(255,255,255,.95)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', margin: '-4px 0 28px' }}>
          <img src="/logo.svg" alt="Team Carol Macedo" style={{ width: '92px', height: 'auto', display: 'block' }} />
          <button onClick={() => navigate('/aluna/perfil')} style={{ height: '42px', border: '1px solid rgba(216,202,182,.86)', borderRadius: '999px', background: 'rgba(255,255,255,.54)', color: '#7f7165', padding: '0 14px', fontSize: '13px', fontWeight: 500 }}>
            {isPt ? 'Perfil' : 'Profile'}
          </button>
        </div>

        <button onClick={() => navigate('/aluna/hoje')} style={{ height: '38px', padding: '0 14px', background: 'rgba(255,255,255,.76)', border: '1px solid rgba(255,255,255,.72)', color: '#7f7165', borderRadius: '999px', fontSize: '12px', cursor: 'pointer', marginBottom: '18px', boxShadow: '0 10px 24px rgba(82,69,57,.055)' }}>
          {isPt ? 'Voltar' : 'Back'}
        </button>

        <span style={{ display: 'block', color: '#895b40', fontSize: '11px', fontWeight: 600, letterSpacing: '.09em', textTransform: 'uppercase', marginBottom: '8px' }}>{isPt ? 'Saúde' : 'Health'}</span>
        <h1 style={{ fontSize: '30px', color: '#251c19', margin: 0, fontWeight: 650, letterSpacing: 0 }}>{isPt ? 'Questionários' : 'Questionnaires'}</h1>
        <p style={{ color: '#8c7f70', margin: '8px 0 24px', fontSize: '13px', lineHeight: 1.55 }}>
          {isPt
            ? 'Responda os questionários iniciais para personalizarmos seu treino, nutrição e acompanhamento.'
            : 'Answer the initial questionnaires so we can personalize your training, nutrition and follow-up.'}
        </p>

        {!loading && (
          <div style={{ background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', padding: '16px', marginBottom: '14px', boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', marginBottom: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ width: '42px', height: '42px', borderRadius: '17px', background: '#d9ddc1', color: '#5e6840', display: 'grid', placeItems: 'center' }}><IconClipboard /></div>
                <div>
                  <div style={{ fontSize: '14px', color: '#251c19', fontWeight: 600 }}>{isPt ? 'Status da consulta' : 'Consultation status'}</div>
                  <div style={{ fontSize: '12px', color: '#8c7f70', marginTop: '2px' }}>
                    {isPt ? `${totalRespondidos} de ${TIPOS.length} respondidos` : `${totalRespondidos} of ${TIPOS.length} completed`}
                  </div>
                </div>
              </div>
              <strong style={{ color: '#895b40', fontSize: '20px' }}>{progresso}%</strong>
            </div>
            <div style={{ height: '6px', borderRadius: '999px', background: '#eee8de', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${progresso}%`, background: '#895b40', borderRadius: '999px' }} />
            </div>
          </div>
        )}

        {TIPOS.map(tipo => {
          const q = QUESTIONARIOS[tipo];
          const ultima = respondidos[tipo];
          return (
            <div key={tipo} onClick={() => navigate(`/aluna/questionario/${tipo}`)}
              style={{ minHeight: '82px', background: 'rgba(255,255,255,.78)', border: '1px solid rgba(255,255,255,.72)', borderRadius: '28px', padding: '14px', marginBottom: '12px', boxShadow: '0 12px 28px rgba(82,69,57,.055), inset 0 1px 0 rgba(255,255,255,.84)', display: 'grid', gridTemplateColumns: '44px 1fr auto', alignItems: 'center', gap: '13px', cursor: 'pointer' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '18px', display: 'grid', placeItems: 'center', background: ultima ? '#d9ddc1' : '#f0e8df', color: ultima ? '#5e6840' : '#895b40', fontSize: '20px', flexShrink: 0 }}>{q.icone}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: 600, color: '#251c19', marginBottom: '4px', lineHeight: 1.2 }}>{q.titulo}</div>
                <div style={{ fontSize: '12px', color: '#8c7f70', lineHeight: 1.4 }}>{q.descricaoCurta}</div>
                {!loading && (
                  <div style={{ fontSize: '11px', fontWeight: 600, marginTop: '7px', color: ultima ? '#5e6840' : '#895b40' }}>
                    {ultima
                      ? (isPt ? `Respondido em ${fmtDate(ultima)}` : `Completed on ${fmtDate(ultima)}`)
                      : (isPt ? 'Ainda não respondido' : 'Not completed yet')}
                  </div>
                )}
              </div>
              <span style={{ fontSize: '20px', color: '#8c7f70', flexShrink: 0 }}>›</span>
            </div>
          );
        })}
      </div>

      <AlunaTabBar current="saude" />
    </div>
  );
}
